/* oxlint-disable */
'use client';

import React, {
  Suspense,
  useState,
  useEffect,
  use,
} from 'react';

// import Image from 'next/image';

import Tournaments from '@/features/casino/components/Tournaments';

import { getTournaments } from '@/sanity/sanity-utils';

import LoadingSpinner from '@/components/common/LoadingSpinner';
import { HomeLogicWrapperPublic } from '@/features/v2/shared/Wrappers';

export default function Torneo({ params }: { params: Promise<{ slug: string }> }) {
  const resolvedParams = use(params);
  const [cmsTournament, setCmsTournament] = useState<any>();
  const [backgroundImage, setBackgroundImage] = useState<string>('/img/background/torneobackground.webp');

  useEffect(() => {
    const cmsTournamentFetch = async () => {
      const getCmsTournament = await getTournaments();
      setCmsTournament(
        getCmsTournament.filter((t: any) => {
          return t.slug === resolvedParams.slug;
        })[0],
      );
      setBackgroundImage(cmsTournament?.imageUrl.toString());
    };
    cmsTournamentFetch();
  }, [cmsTournament?.imageUrl, resolvedParams.slug]);

  return (
    <>
      <HomeLogicWrapperPublic />
      <div className="control-padding">
        <Suspense fallback={<LoadingSpinner />}>
          {backgroundImage && (
            <div className="relative flex flex-col items-stretch sm:pl-8 pb-5 max-w-full overflow-hidden bg-linear-to-r from-sivarbet-border to-black">
              {/* <Image
                src={backgroundImage}
                alt={cmsTournament?.altLanding}
                fill
                objectPosition="center"
                className="object-cover z-[-1] opacity-30"
              /> */}
              <Tournaments slug={resolvedParams.slug} cmsTournament={cmsTournament} />
            </div>
          )}
        </Suspense>
      </div>
    </>
  );
}
